module.exports = "https://hwyhw-static.smarket.net.cn/519/seminar/2202102963240899/minisite/ccbbddfd83a6c2da543911dcec695203.png";